/** @format */

import React from 'react';
import Translate from '@components/translation/translate-text-wrapper';

/**
 * Algolia Panel.
 */
const Panel = ({
  children,
  header,
  footer,
}: {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}) => {
  return (
    <div className="search-panel">
      {header && (
        <h3 className="panel-header">
          <Translate>{header}</Translate>
        </h3>
      )}
      <div className="panel-body">{children}</div>
      {footer && <div className="panel-footer">{footer}</div>}
    </div>
  );
};
export default Panel;
